export const onlyNumbers = (text?: string) => {
  if (!text) return '';

  return text.replace(/\D/g, '');
};
